module.exports = __webpack_public_path__ + "static/img/active_vip_02.4dcd569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_02.jpg
// module id = 5lFI
// module chunks = 0